import * as React from "react"
import useIntersectionObserver from "@react-hook/intersection-observer"

import useKeyPress from "../components/common/use-key-press"

import * as styles from "../components/magazine.module.css"

function Magazine({ title, file, pages }) {
  const [pageNumber, setPageNumber] = React.useState(1)
  const [numPages] = React.useState(pages ? pages.length : 0)
  /* Handling switching pages through gestures */
  // Page switching with arrow keys
  const leftPress = useKeyPress("ArrowLeft")
  const rightPress = useKeyPress("ArrowRight")
  // Page switching with swipes
  const [touchStart, setTouchStart] = React.useState(0)
  const [touchEnd, setTouchEnd] = React.useState(0)

  /* Handling that the arrow keys only target the PDF that's on screen */
  const containerRef = React.useRef()
  const lockRef = React.useRef(false)
  const { isIntersecting } = useIntersectionObserver(containerRef)
  if (isIntersecting && !lockRef.current) {
    lockRef.current = true
  }

  const handlePrevPage = () =>
    setPageNumber(pageNumber => (pageNumber !== 1 ? pageNumber - 1 : 1))
  const handleNextPage = () =>
    setPageNumber(pageNumber =>
      pageNumber !== numPages ? pageNumber + 1 : numPages
    )

  React.useEffect(() => {
    if (isIntersecting)
      if (leftPress)
        // Check if pdf is on screen
        setPageNumber(pageNumber => (pageNumber !== 0 ? pageNumber - 1 : 0))
      else if (rightPress)
        setPageNumber(pageNumber =>
          pageNumber !== numPages ? pageNumber + 1 : numPages
        )
  }, [leftPress, rightPress, numPages, isIntersecting])

  // Touch handlers
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX)
  }
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX)
  }
  const handleTouchEnd = () => {
    const sensitivity = 75 // 150 for less sensitivity
    if (touchStart - touchEnd > sensitivity) {
      // do your stuff here for left swipe
      handleNextPage()
    }

    if (touchStart - touchEnd < -sensitivity) {
      // do your stuff here for right swipe
      handlePrevPage()
    }
  }

  /* Render */
  const pageControls = (
    <div className={`my-3 ${styles.controls}`}>
      <button
        disabled={pageNumber === 1}
        type="button"
        onClick={handlePrevPage}
      >
        ‹
      </button>
      <span>
        {pageNumber} of {numPages}
      </span>
      <button
        disabled={pageNumber === numPages}
        type="button"
        onClick={handleNextPage}
      >
        ›
      </button>
    </div>
  )

  return (
    <div ref={containerRef}>
      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {pageControls}
        <img
          src={pages[pageNumber]}
          className="d-block w-100"
          alt={`${title} page ${pageNumber}`}
        />
        {pageControls}
      </div>
    </div>
  )
}

const MagazineDocument = ({ title, file, buy, pages }) => {
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      <h2 className="mt-3">{title}</h2>
      <div className="row mb-1">
        <div className="col">
          <a href={file} download>
            Download
          </a>
        </div>
        <div className="col">
          {buy ? (
            <a href={buy} target="_blank" rel="noreferrer">
              Buy
            </a>
          ) : null}
        </div>
      </div>

      {isClient && <Magazine title={title} file={file} pages={pages} />}
    </>
  )
}

export default MagazineDocument
